import _ from "lodash";

import { float6Normalizer } from "validators";

export const flatRateMapper = (FORM_NAME, dispatch, change, feeTemplate) => {
	const findFlatRateFormValue = _.filter(
		feeTemplate.fieldBlocks,
		template => template.name === "FlatRate",
	);

	if (_.isEmpty(findFlatRateFormValue)) return;

	const findFlatRateAuthorizationFeeValue = _.find(
		findFlatRateFormValue[0].fields,
		{
			name: "flatRateAuthorizationFee",
		},
	);

	const findFlatRateValue = _.find(findFlatRateFormValue[0].fields, {
		name: "flatRate",
	});

	const findFlatRateSalesTransactionFeeValue = _.find(
		findFlatRateFormValue[0].fields,
		{
			name: "flatRateSalesTransactionFee",
		},
	);

	const findPassCardBrandFeesValue = _.find(findFlatRateFormValue[0].fields, {
		name: "passCardBrandFees",
	});

	const findFlatRateIsRiseFreeValue = _.find(
		findFlatRateFormValue[0].fields,
		{
			name: "flatRateIsRiseFree",
		},
	);

	dispatch(
		change(
			FORM_NAME,
			"flatRateAuthorizationFee",
			float6Normalizer(findFlatRateAuthorizationFeeValue?.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"flatRate",
			float6Normalizer(findFlatRateValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"flatRateSalesTransactionFee",
			float6Normalizer(findFlatRateSalesTransactionFeeValue?.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"passCardBrandFees",
			findPassCardBrandFeesValue.value,
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"flatRateIsRiseFree",
			findFlatRateIsRiseFreeValue.value,
		),
	);
};
